var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
// A src already carrying a scheme (`https:`, `blob:`, `data:`…), a protocol-relative `//cdn/…` or a
// root-relative `/asset.png` is left untouched: only a bare host (`www.x.com/…`, `x.com/…`) is
// missing a protocol the browser needs. Guarding here matters because `addHttpsProtocol` would
// otherwise prepend `https://` to `blob:`/`data:` object URLs and break them.
const normalizeSrc = (src) => {
    var _a;
    if (typeof src !== 'string' || !src || /^([a-z][\w+.-]*:|\/)/i.test(src)) {
        return src;
    }
    return (_a = addHttpsProtocol(src)) !== null && _a !== void 0 ? _a : src;
};
// Headless drop-in replacement for a native <img>. Many stored image URLs are persisted without a
// scheme (e.g. `www.example.com/x.jpg` or a raw game box-art template), which the browser cannot
// load, so every redesign image render funnels its `src` through here instead of each call site
// having to remember to normalize it. Forwards every native attribute and the ref.
export const Img = forwardRef((_a, ref) => {
    var { src, alt = '' } = _a, rest = __rest(_a, ["src", "alt"]);
    return (<img ref={ref} alt={alt} src={normalizeSrc(src)} {...rest}/>);
});
Img.displayName = 'Img';
